import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'lab',
    serviceName: 'graphql',
    query: gql`
      query lab($ids: [String]) {
        lab(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
